
import HttpUtil from "@/assets/js/HttpUtil";
import delCom from "@/components/DelDataCom.vue";
import uploadFile from "../ShareComponents/UploadFileCom.vue";
import Urls from "@/assets/js/Urls";

import deviceList from "../ShareComponents/DeviceChooseCom.vue";
import Vue from "vue";
import dialogCom from "@/components/ModelCom.vue";
export default Vue.extend({
  components: { dialogCom, delCom, deviceList, uploadFile },
  data() {
    return {
      fileTitle: "",
      noexcel: false,
      delUrl: Urls.DelSoft,
      currentSid: "",
      projectForm: {
        sid: null,
        groupName: "",
        enabled: true,
      } as any,
      dialogTitle: {
        title: "新增分组",
      },
      total: 0,
      search: "",
      groups: [] as any[],
      devices: [] as any[],
      currentGroup: {} as any,
      savedDevice: [] as any[],
      showedDevice: [] as any,
      props: {
        label: "groupName",
        children: "children",
      },
      addLoops: [] as any[],
      addDevices: [] as any[],
      deleteDevice: [] as any,
      dtype: 0,
    };
  },
  mounted() {
    this.getGroups();
  },
  methods: {
    async removeDevice() {
      if (!this.currentGroup || !this.currentGroup.sid) {
        throw "请选择一个分组";
      }
      let data = {
        sid: this.currentGroup.sid,
        devices: [] as any[],
      };
      this.deleteDevice.forEach((element: any) => {
        data.devices.push(element.sid);
      });
      if (this.currentGroup.groupType != 2) {
        await HttpUtil.XCHttpPost(Urls.RemoveDeviceToSoftGroup, data, true, false);
      } else {
        await HttpUtil.XCHttpPost(Urls.RemoveLoopsToSoftGroup, data, true, false);
      }
      this.nodeClick(this.currentGroup);
    },
    async exportDevice() {
      if (!this.currentGroup || !this.currentGroup.sid) {
        throw "请选择一个分组";
      }
      const ret = await HttpUtil.XCHttpPost(
        Urls.ExportGroupDevice,
        this.currentGroup.sid,
        true,
        false
      );

      window.open(ret);
    },
    importDevice() {
      this.fileTitle = "请选择上传Excel文件";
      this.noexcel = false;
      const upload: any = this.$refs.uploadFile;
      upload.open();
    },
    async imported(file: any) {
      var obj = {
        sid: this.currentGroup.sid,
        file: file.File,
      };
      await HttpUtil.XCHttpFormData(Urls.SoftGroupImport, obj, true, false);
      const upload: any = this.$refs.uploadFile;
      upload.hiden();
      this.nodeClick(this.currentGroup);
    },
    deviceOpend() {
      const dialgo: any = this.$refs.deviceList;
      dialgo.getList();
    },
    closeDeviceList() {
      var dialog: any = this.$refs.addDevice;
      dialog.hiden();
    },
    deviceSelectChange(Val: any) {
      this.addDevices = Val;
    },
    deviceHandleSelectionChange(val: any) {
      this.deleteDevice = val;
    },
    async loopAddClick() {
      let data = {
        sid: this.currentGroup.sid,
        devices: [] as any[],
      };
      this.addLoops.forEach((element) => {
        data.devices.push(element.sid);
      });
      await HttpUtil.XCHttpPost(Urls.AddLoopsToSoftGroup, data, true, false);
      const detail: any = await HttpUtil.XCHttpPost(
        Urls.GetSoft,
        this.currentGroup.sid,
        true,
        false
      );
      this.savedDevice = detail.subDevices;
      this.showedDevice = detail.subDevices;
    },
    async deviceAddClick() {
      let data = {
        sid: this.currentGroup.sid,
        devices: [] as any[],
      };
      this.addDevices.forEach((element) => {
        data.devices.push(element.sid);
      });
      await HttpUtil.XCHttpPost(Urls.AddDeviceToSoftGroup, data, true, false);
      const detail: any = await HttpUtil.XCHttpPost(
        Urls.GetSoft,
        this.currentGroup.sid,
        true,
        false
      );
      this.savedDevice = detail.subDevices;
      this.showedDevice = detail.subDevices;
      this.closeDeviceList();
    },
    closeLoopDialog() {
      const dialog: any = this.$refs.loopDialog;
      dialog.hiden();
    },
    loopSelectChange(val: any) {
      this.addLoops = val;
    },
    openLoop() {
      const list: any = this.$refs.loopList;
      list.getList();
    },
    closeDialog() {
      const dialog: any = this.$refs.projectDialog;
      dialog.hiden();
    },
    async nodeClick(data: any) {
      this.currentGroup = data;
      this.total = 0;
      if (this.currentGroup && this.currentGroup.sid) {
        const detail: any = await HttpUtil.XCHttpPost(
          Urls.GetSoft,
          this.currentGroup.sid,
          true,
          false
        );
        this.savedDevice = detail.subDevices;
        this.showedDevice = this.savedDevice;
        this.total = this.savedDevice.length;
        this.dtype = this.currentGroup.groupType;
      }
    },
    async getGroups() {
      const ret: any = await HttpUtil.XCHttpPost(Urls.GetSoftGroups, -1, true, false);
      this.groups = [
        {
          groupName: "根目录",
          sid: null,
          children: ret,
        },
      ];
    },
    searchClick() {
      this.showedDevice = this.savedDevice.filter(
        (r) =>
          (r.name && r.name.indexOf(this.search) != -1) ||
          (r.desc && r.desc.indexOf(this.search) != -1)
      );
      console.log(this.showedDevice);
    },
    addGroup() {
      this.dialogTitle.title = "新增软件分组";
      const dialog: any = this.$refs.projectDialog;
      if (!this.currentGroup) {
        this.currentGroup = {
          groupName: "根目录",
          sid: null,
        };
      }
      this.projectForm.parentSid = this.currentGroup.sid;
      this.projectForm.sid = null;
      dialog.show();
    },
    editGroup() {
      if (!this.currentGroup || !this.currentGroup.sid) {
        throw "请选择一个分组";
      }
      this.dialogTitle.title = "编辑软件分组";
      const dialog: any = this.$refs.projectDialog;
      this.projectForm.sid = this.currentGroup.sid;
      this.projectForm.groupName = this.currentGroup.groupName;

      dialog.show();
    },
    delGroup() {
      if (!this.currentGroup || !this.currentGroup.sid) {
        throw "请选择一个分组";
      }
      this.currentSid = this.currentGroup.sid;
      const dialog: any = this.$refs.del;
      dialog.show();
    },
    addDevice() {
      if (!this.currentGroup || !this.currentGroup.sid) {
        throw "请选择一个分组";
      }
      if (this.currentGroup.groupType != 2) {
        var dialog: any = this.$refs.addDevice;
        dialog.show();
      } else {
        var dialog2: any = this.$refs.loopDialog;
        dialog2.show();
      }
    },
    async onSubmit() {
      if (!this.projectForm.sid) {
        await HttpUtil.XCHttpPost(Urls.AddSoft, this.projectForm, true, false);
      } else {
        await HttpUtil.XCHttpPost(Urls.UpdateSoft, this.projectForm, true, false);
      }
      this.closeDialog();
      this.getGroups();
    },
  },
});
